package com.jingfangpai.common.orm.mapping

import kotlinx.serialization.Serializable
import com.jingfangpai.common.orm.mapping.enums.SyndromeType
import com.jingfangpai.common.orm.mapping.enums.SyndromeOriginRefEntityType
import com.jingfangpai.common.data.type.DateTime
import com.jingfangpai.common.data.serializer.DateTimeSerializer
import com.jingfangpai.common.orm.mapping.enums.SyndromeStatus

@Serializable
open class Syndrome(var id: String? = null){
	var name: String? = null
	var groupName: String? = null
	var baseId: String? = null
	var type: SyndromeType? = null
	var originRefEntityType: SyndromeOriginRefEntityType? = null
	var originRefId: String? = null
	var description: String? = null
	var weight: Int? = null
	@Serializable(with = DateTimeSerializer::class)
	var createdOn: DateTime? = null
	var createdBy: String? = null
	var status: SyndromeStatus? = null
	var organizationId: String? = null
	var userId: String? = null
	var todo: String? = null

	override fun equals(other: Any?): Boolean {
		if (this === other) return true
		if (other == null || this::class != other::class) return false
		other as Syndrome
		if (id != other.id) return false
		if (name != other.name) return false
		if (groupName != other.groupName) return false
		if (baseId != other.baseId) return false
		if (type != other.type) return false
		if (originRefEntityType != other.originRefEntityType) return false
		if (originRefId != other.originRefId) return false
		if (description != other.description) return false
		if (weight != other.weight) return false
		if (createdOn != other.createdOn) return false
		if (createdBy != other.createdBy) return false
		if (status != other.status) return false
		if (organizationId != other.organizationId) return false
		if (userId != other.userId) return false
		if (todo != other.todo) return false
		return true
	}

	override fun hashCode(): Int {
		var result = 0
		result = 31 * result + (id?.hashCode() ?: 0)
		result = 31 * result + (name?.hashCode() ?: 0)
		result = 31 * result + (groupName?.hashCode() ?: 0)
		result = 31 * result + (baseId?.hashCode() ?: 0)
		result = 31 * result + (type?.hashCode() ?: 0)
		result = 31 * result + (originRefEntityType?.hashCode() ?: 0)
		result = 31 * result + (originRefId?.hashCode() ?: 0)
		result = 31 * result + (description?.hashCode() ?: 0)
		result = 31 * result + (weight?.hashCode() ?: 0)
		result = 31 * result + (createdOn?.hashCode() ?: 0)
		result = 31 * result + (createdBy?.hashCode() ?: 0)
		result = 31 * result + (status?.hashCode() ?: 0)
		result = 31 * result + (organizationId?.hashCode() ?: 0)
		result = 31 * result + (userId?.hashCode() ?: 0)
		result = 31 * result + (todo?.hashCode() ?: 0)
		return result
	}

}
